import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

const ItemCrs = (props) => {

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            setProgress(props.data.pass_percent)
        }, 300);
    }, [])

    return (
        <Link to={`/Education/mycourses/${props.data.id}`} className="item-cors">
            <h4>{props.data.title}</h4>
            <span>{props.data.string_date}</span>
            <div className="details">
                <strong>امتیاز من از این کرس : </strong><span>{props.data.score}<i className="icon-favourite2"></i></span>
            </div>
            <div className="grade">
                <span>نمره قبولی آزمون : </span><strong>{props.data.pass_score}</strong>
            </div>
            <div className="progress-course">
                <CircularProgress
                    variant="determinate"
                    value={progress} />
                <strong>{props.data.pass_percent}%</strong>
                <span>درصد پیشرفت</span>
            </div>
        </Link>
    );
}

export default ItemCrs;